import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column justify-center align-center",
  style: {"height":"100vh"}
}
const _hoisted_2 = { class: "mt-16" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_sm_btn_outlined = _resolveComponent("sm-btn-outlined")!
  const _component_sm_list_icon = _resolveComponent("sm-list-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_img, {
      src: "/resources/landing/smooth-e_white_logo_tate.png",
      width: "287px",
      "max-height": 228
    }),
    _createVNode(_component_sm_btn_outlined, {
      text: "ログイン",
      color: "white",
      class: "mt-4",
      onClickBtn: _ctx.goToLogin
    }, null, 8, ["onClickBtn"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_sm_list_icon, {
        style: {"color":"white"},
        "left-icon": "$description_outlined",
        "left-icon-color": "white",
        text: "初回登録の詳細な手順",
        "text-color": "white",
        "right-icon": "$chevron_right_round",
        "right-icon-color": "white",
        onClick: _ctx.goToInitialRegistrationManual
      }, null, 8, ["onClick"])
    ])
  ]))
}